// Slim bar shown when the running tab is behind the live server build (see
// useVersionCheck). Brand-locked: warm cream bar, brown text, rust "Refresh"
// CTA — the same palette idiom as the rest of the staff shell.
//
// LAYOUT: this renders in NORMAL DOCUMENT FLOW (no position:fixed/absolute/
// sticky), mounted ONCE as the first child of RequireAuth — i.e. directly
// above the shell. It therefore RESERVES its own vertical space and pushes the
// whole shell down instead of painting over it, so it can never cover the
// Shell header/hamburger/sidebar logo or the Command Center nav row at any
// scroll position or breakpoint. (An earlier `fixed top-0` version overlaid
// and intercepted clicks across the top strip — that was the review defect.)
//
// Mounted only inside RequireAuth, so the public share pages (/p /o /po /i)
// and /login — which don't use RequireAuth — never show internal deploy chrome.
import { RefreshCw, X } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { useVersionCheck } from "@/lib/useVersionCheck";

export function VersionUpdateBanner() {
  const { showBanner, dismiss } = useVersionCheck();

  if (!showBanner) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex w-full items-center justify-center gap-3 border-b border-brown-100 bg-cream-100 px-4 py-2 text-sm text-brown-500"
    >
      <RefreshCw className="h-4 w-4 shrink-0 text-rust" aria-hidden />
      <span className="font-medium">
        A new version of merch&rsquo;d is available.
      </span>
      <Button
        variant="destructive"
        size="sm"
        onClick={() => window.location.reload()}
      >
        Refresh
      </Button>
      <button
        type="button"
        onClick={dismiss}
        aria-label="Dismiss"
        className="ml-1 rounded-md p-1 text-brown-300 transition-colors hover:bg-cream-200 hover:text-brown-500"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
